/**
 * 52S Solutions Analytics & GTM DataLayer Tracking Utility
 * Safely dispatches events to window.dataLayer on the client side.
 */

export interface AnalyticsEventParams {
  nudge_type?: string;
  asset_id?: string;
  source?: string;
  cta_action?: string;
  email?: string;
  project_type?: string;
  timeline?: string;
  budget_range?: string;
  reason?: string;
  path?: string;
  [key: string]: unknown;
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

/**
 * Dispatches an event payload to Google Tag Manager / Google Analytics dataLayer.
 * Handles SSR safety and undefined dataLayer gracefully.
 */
export function trackEvent(eventName: string, params: AnalyticsEventParams = {}): void {
  if (typeof window === "undefined") return;

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...params,
      timestamp: new Date().toISOString(),
    });
  } catch (err) {
    console.warn("[Analytics] Error pushing event to dataLayer:", err);
  }
}
